var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgChatHistory = function SvgChatHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "chat-history_svg__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 85.333c235.648 0 426.667 191.019 426.667 426.667S747.648 938.667 512 938.667a424.832 424.832 0 01-200.875-50.134L85.333 938.667 135.51 712.96A425.216 425.216 0 0185.333 512C85.333 276.352 276.352 85.333 512 85.333zm0 85.334a341.333 341.333 0 00-301.227 502.016l14.934 27.904-27.99 125.696L323.5 798.379l27.861 14.89A339.2 339.2 0 00512 853.333a341.333 341.333 0 000-682.666zm42.667 128V512h170.666v85.333h-256V298.667h85.334z"
  })));
};
export default SvgChatHistory;